/* ==== extrait de vc ==== */

  document.addEventListener('DOMContentLoaded', function() {
    // Immediately apply fixed dimensions to all video items
    const applyFixedDimensions = function() {
      document.querySelectorAll('.video-item').forEach(item => {
        item.style.width = '132px';
        item.style.minWidth = '132px';
        item.style.maxWidth = '132px';
        item.style.flexBasis = '132px';
        item.style.margin = '0';
        item.style.padding = '0';
        
        const thumbnail = item.querySelector('.video-thumbnail');
        if (thumbnail) {
          thumbnail.style.height = '235px';
          thumbnail.style.width = '100%';
          thumbnail.style.borderRadius = '6px';
        }
        
        const playButton = item.querySelector('.play-button');
        if (playButton) {
          playButton.style.position = 'absolute';
          playButton.style.bottom = '9px';
          playButton.style.left = '9px';
          playButton.style.zIndex = '1';
          playButton.style.display = 'flex';
          playButton.style.visibility = 'visible';
          playButton.style.opacity = '1';
        }
      });
    };
    
    // Apply dimensions immediately and after a short delay
    applyFixedDimensions();
    setTimeout(applyFixedDimensions, 100);
    setTimeout(applyFixedDimensions, 500);
    
    // Handle window resize events
    window.addEventListener('resize', applyFixedDimensions);
    
    // Play button click handler - UPDATED for inline playback
    document.querySelectorAll('.play-button').forEach(button => {
      button.addEventListener('click', function() {
        const videoItem = this.closest('.video-item');
        const videoThumbnail = videoItem.querySelector('.video-thumbnail');
        const videoType = videoItem.querySelector('.video-type');
        
        if (!videoType) return; // No video info available
        
        // Check if video is already playing
        if (this.classList.contains('playing')) {
          // Video is playing, need to pause it
          const inlineContainer = videoThumbnail.querySelector('.inline-video-container');
          if (inlineContainer) {
            // Find the video or iframe element
            const videoEl = inlineContainer.querySelector('video');
            const iframeEl = inlineContainer.querySelector('iframe');
            
            if (videoEl) {
              // Handle Shopify video
              videoEl.pause();
            } else if (iframeEl) {
              // Handle YouTube or Vimeo
              const src = iframeEl.src;
              if (src.includes('youtube.com')) {
                // Pause YouTube video - using better approach with postMessage
                const iframe = iframeEl;
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              } else if (src.includes('vimeo.com')) {
                // Pause Vimeo video - using better approach with postMessage
                const iframe = iframeEl;
                iframe.contentWindow.postMessage('{"method":"pause"}', '*');
              }
            }
          }
          
          // Change button back to play
          this.innerHTML = `
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="12" fill="${this.querySelector('circle').getAttribute('fill')}"/>
              <polygon points="10,8 16,12 10,16" fill="white"/>
            </svg>
          `;
          this.setAttribute('aria-label', 'Play video');
          this.classList.remove('playing');
          
          return;
        }
        
        // Check if video container already exists but is paused
        const existingContainer = videoThumbnail.querySelector('.inline-video-container');
        if (existingContainer) {
          // Resume playback of existing video
          const videoEl = existingContainer.querySelector('video');
          const iframeEl = existingContainer.querySelector('iframe');
          
          if (videoEl) {
            // Resume Shopify video
            videoEl.play();
          } else if (iframeEl) {
            // Resume YouTube or Vimeo
            const src = iframeEl.src;
            if (src.includes('youtube.com')) {
              // Play YouTube video
              iframeEl.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (src.includes('vimeo.com')) {
              // Play Vimeo video
              iframeEl.contentWindow.postMessage('{"method":"play"}', '*');
            }
          }
          
          // Change to pause button
          this.innerHTML = `
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="12" fill="${this.querySelector('circle').getAttribute('fill')}"/>
              <rect x="8" y="8" width="3" height="8" fill="white"/>
              <rect x="13" y="8" width="3" height="8" fill="white"/>
            </svg>
          `;
          this.setAttribute('aria-label', 'Pause video');
          this.classList.add('playing');
          
          return;
        }
        
        // Transform play button into pause button
        this.innerHTML = `
          <svg viewBox="0 0 24 24" width="24" height="24">
            <circle cx="12" cy="12" r="12" fill="${this.querySelector('circle').getAttribute('fill')}"/>
            <rect x="8" y="8" width="3" height="8" fill="white"/>
            <rect x="13" y="8" width="3" height="8" fill="white"/>
          </svg>
        `;
        this.setAttribute('aria-label', 'Pause video');
        this.classList.add('playing');
        
        // Mark this thumbnail as currently playing
        videoThumbnail.classList.add('playing');
        
        const type = videoType.getAttribute('data-type');
        
        // Create container for inline video if needed
        let inlineContainer = videoThumbnail.querySelector('.inline-video-container');
        if (!inlineContainer) {
          // Remove the current static image/thumbnail
          const existingImg = videoThumbnail.querySelector('img:not(.unmute-btn)');
          if (existingImg) {
            existingImg.style.display = 'none';
          }
          
          inlineContainer = document.createElement('div');
          inlineContainer.className = 'inline-video-container';
          inlineContainer.style.position = 'absolute';
          inlineContainer.style.top = '0';
          inlineContainer.style.left = '0';
          inlineContainer.style.width = '100%';
          inlineContainer.style.height = '100%';
          inlineContainer.style.zIndex = '1';
          videoThumbnail.appendChild(inlineContainer);
          
          // Add close button
          const closeButton = document.createElement('button');
          closeButton.className = 'inline-close-btn';
          closeButton.innerHTML = '✕';
          closeButton.setAttribute('aria-label', 'Close video');
          closeButton.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
          inlineContainer.appendChild(closeButton);
          
          // Close button functionality
          closeButton.addEventListener('click', function(e) {
            e.stopPropagation();
            // Clear the container
            inlineContainer.innerHTML = '';
            // Remove the playing class
            videoThumbnail.classList.remove('playing');
            // Reset play button to original state
            button.innerHTML = `
              <svg viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="12" fill="${button.querySelector('circle').getAttribute('fill')}"/>
                <polygon points="10,8 16,12 10,16" fill="white"/>
              </svg>
            `;
            button.setAttribute('aria-label', 'Play video');
            button.classList.remove('playing');
            // Show the thumbnail image again
            const existingImg = videoThumbnail.querySelector('img:not(.unmute-btn)');
            if (existingImg) {
              existingImg.style.display = 'block';
            }
            // Remove the container
            inlineContainer.remove();
          });
        }
        
        if (type === 'youtube') {
          const youtubeId = videoType.getAttribute('data-id');
          inlineContainer.innerHTML = `
            <iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&rel=0&playsinline=1&enablejsapi=1&controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;" id="youtube-player-${youtubeId}"></iframe>
          `;
          
          // Add volume toggle button
          const volumeBtn = document.createElement('button');
          volumeBtn.className = 'unmute-btn force-visible';
          volumeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
          volumeBtn.setAttribute('aria-label', 'Unmute video');
          volumeBtn.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
          volumeBtn.style.zIndex = '1000';
          inlineContainer.appendChild(volumeBtn);
          
          // Track mute state
          let isMuted = true;
          
          volumeBtn.addEventListener('click', function() {
            const iframe = inlineContainer.querySelector('iframe');
            if (isMuted) {
              // Unmute YouTube video
              iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
              // Change to volume-on icon
              this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';
              this.setAttribute('aria-label', 'Mute video');
              isMuted = false;
            } else {
              // Mute YouTube video
              iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
              // Change to volume-off icon
              this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
              this.setAttribute('aria-label', 'Unmute video');
              isMuted = true;
            }
          });
          
          // Re-add close button after innerHTML change
          const closeButton = document.createElement('button');
          closeButton.className = 'inline-close-btn';
          closeButton.innerHTML = '✕';
          closeButton.setAttribute('aria-label', 'Close video');
          closeButton.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
          inlineContainer.appendChild(closeButton);
          
          // Close button functionality
          closeButton.addEventListener('click', function(e) {
            e.stopPropagation();
            inlineContainer.innerHTML = '';
            videoThumbnail.classList.remove('playing');
            button.innerHTML = `
              <svg viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="12" fill="${button.querySelector('circle').getAttribute('fill')}"/>
                <polygon points="10,8 16,12 10,16" fill="white"/>
              </svg>
            `;
            button.setAttribute('aria-label', 'Play video');
            button.classList.remove('playing');
            const existingImg = videoThumbnail.querySelector('img:not(.unmute-btn)');
            if (existingImg) {
              existingImg.style.display = 'block';
            }
            inlineContainer.remove();
          });
          
        } else if (type === 'vimeo') {
          const vimeoId = videoType.getAttribute('data-id');
          inlineContainer.innerHTML = `
            <iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&muted=1&playsinline=1&transparent=0&background=0&api=1&controls=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 0;" id="vimeo-player-${vimeoId}"></iframe>
            <button class="unmute-btn" style="background-color: ${button.querySelector('circle').getAttribute('fill')};">Unmute</button>
          `;
          
          const unmuteBtn = inlineContainer.querySelector('.unmute-btn');
          unmuteBtn.addEventListener('click', function() {
            const iframe = inlineContainer.querySelector('iframe');
            const currentSrc = iframe.src;
            iframe.src = currentSrc.replace('&muted=1', '');
            this.style.display = 'none';
          });
          
          // Re-add close button after innerHTML change
          const closeButton = document.createElement('button');
          closeButton.className = 'inline-close-btn';
          closeButton.innerHTML = '✕';
          closeButton.setAttribute('aria-label', 'Close video');
          closeButton.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
          inlineContainer.appendChild(closeButton);
          
          // Close button functionality
          closeButton.addEventListener('click', function(e) {
            e.stopPropagation();
            inlineContainer.innerHTML = '';
            videoThumbnail.classList.remove('playing');
            button.innerHTML = `
              <svg viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="12" fill="${button.querySelector('circle').getAttribute('fill')}"/>
                <polygon points="10,8 16,12 10,16" fill="white"/>
              </svg>
            `;
            button.setAttribute('aria-label', 'Play video');
            button.classList.remove('playing');
            const existingImg = videoThumbnail.querySelector('img:not(.unmute-btn)');
            if (existingImg) {
              existingImg.style.display = 'block';
            }
            inlineContainer.remove();
          });
          
        } else if (type === 'shopify') {
          // Handle Shopify videos - use pre-generated Shopify video tag
          const hiddenVideoData = videoThumbnail.querySelector('.hidden-video-data');
          
          if (hiddenVideoData) {
            // Get the Shopify video tag from the hidden container
            const videoHTML = hiddenVideoData.innerHTML;
            
            // Clear and add the Shopify video
            inlineContainer.innerHTML = videoHTML;
            
            // Find the video element that Shopify created
            const videoElement = inlineContainer.querySelector('video');
            
            if (videoElement) {
              // Make sure video has proper styles
              videoElement.style.width = '100%';
              videoElement.style.height = '100%';
              videoElement.style.objectFit = 'cover';
              videoElement.controls = false;
              videoElement.muted = true;
              videoElement.autoplay = true;
              videoElement.setAttribute('playsinline', true);
              
              // Add volume button with toggle functionality
              const volumeBtn = document.createElement('button');
              volumeBtn.className = 'unmute-btn force-visible';
              volumeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';
              volumeBtn.setAttribute('aria-label', 'Toggle sound');
              volumeBtn.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
              volumeBtn.style.zIndex = '1000';
              inlineContainer.appendChild(volumeBtn);
              
              volumeBtn.addEventListener('click', function() {
                if (videoElement.muted) {
                  // Unmute the video
                  videoElement.muted = false;
                  // Change to volume-on icon
                  this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';
                  this.setAttribute('aria-label', 'Mute video');
                } else {
                  // Mute the video
                  videoElement.muted = true;
                  // Change to volume-off icon
                  this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
                  this.setAttribute('aria-label', 'Unmute video');
                }
              });
              
              // Add close button
              const closeButton = document.createElement('button');
              closeButton.className = 'inline-close-btn force-visible';
              closeButton.innerHTML = '✕';
              closeButton.setAttribute('aria-label', 'Close video');
              closeButton.style.backgroundColor = button.querySelector('circle').getAttribute('fill');
              closeButton.style.zIndex = '1000';
              inlineContainer.appendChild(closeButton);
              
              // Close button functionality
              closeButton.addEventListener('click', function(e) {
                e.stopPropagation();
                inlineContainer.innerHTML = '';
                videoThumbnail.classList.remove('playing');
                button.innerHTML = `
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <circle cx="12" cy="12" r="12" fill="${button.querySelector('circle').getAttribute('fill')}"/>
                    <polygon points="10,8 16,12 10,16" fill="white"/>
                  </svg>
                `;
                button.setAttribute('aria-label', 'Play video');
                button.classList.remove('playing');
                const existingImg = videoThumbnail.querySelector('img:not(.unmute-btn)');
                if (existingImg) {
                  existingImg.style.display = 'block';
                }
                inlineContainer.remove();
              });
              
              // Play the video
              try {
                const playPromise = videoElement.play();
                
                if (playPromise !== undefined) {
                  playPromise.catch(error => {
                    console.warn('Auto-play was prevented. Please interact with the page to play the video.', error);
                    
                    // Create a play button overlay if autoplay fails
                    const manualPlayBtn = document.createElement('button');
                    manualPlayBtn.className = 'manual-play-btn force-visible';
                    manualPlayBtn.innerHTML = '<span>▶</span>';
                    manualPlayBtn.style.position = 'absolute';
                    manualPlayBtn.style.top = '50%';
                    manualPlayBtn.style.left = '50%';
                    manualPlayBtn.style.transform = 'translate(-50%, -50%)';
                    manualPlayBtn.style.background = button.querySelector('circle').getAttribute('fill');
                    manualPlayBtn.style.border = 'none';
                    manualPlayBtn.style.borderRadius = '50%';
                    manualPlayBtn.style.width = '40px';
                    manualPlayBtn.style.height = '40px';
                    manualPlayBtn.style.cursor = 'pointer';
                    manualPlayBtn.style.zIndex = '1001';
                    manualPlayBtn.style.color = 'white';
                    manualPlayBtn.style.filter = 'none';
                    manualPlayBtn.style.display = 'flex';
                    manualPlayBtn.style.alignItems = 'center';
                    manualPlayBtn.style.justifyContent = 'center';
                    
                    inlineContainer.appendChild(manualPlayBtn);
                    
                    manualPlayBtn.addEventListener('click', function() {
                      videoElement.play();
                      this.remove();
                    });
                  });
                }
              } catch (e) {
                console.error("Error playing Shopify video:", e);
                // Show a helpful message to the user
                const errorMsg = document.createElement('div');
                errorMsg.style.position = 'absolute';
                errorMsg.style.top = '50%';
                errorMsg.style.left = '50%';
                errorMsg.style.transform = 'translate(-50%, -50%)';
                errorMsg.style.color = 'white';
                errorMsg.style.background = 'rgba(0,0,0,0.7)';
                errorMsg.style.padding = '10px';
                errorMsg.style.borderRadius = '5px';
                errorMsg.style.textAlign = 'center';
                errorMsg.style.zIndex = '1001';
                errorMsg.innerHTML = 'Unable to play video. Click to try again.';
                
                errorMsg.addEventListener('click', function() {
                  videoElement.play().catch(err => console.error("Retry failed:", err));
                  this.remove();
                });
                
                inlineContainer.appendChild(errorMsg);
              }
            } else {
              console.error("Shopify video element not found");
            }
          } else {
            console.error("Hidden video data not found");
          }
        }
      });
    });
    
    // Additional step to ensure buttons are visible
    function ensureButtonsVisible() {
      document.querySelectorAll('.play-button').forEach(button => {
        button.classList.add('force-visible');
      });
    }
    
    // Run immediately and after a delay
    ensureButtonsVisible();
    setTimeout(ensureButtonsVisible, 100);
    setTimeout(ensureButtonsVisible, 500);
    setTimeout(ensureButtonsVisible, 1000);
    
    // Run when videos might be interacted with
    document.addEventListener('click', function() {
      setTimeout(ensureButtonsVisible, 100);
    });
  });
